// Centralized environment config with hardcoded production defaults.
// In CRA, `process.env.REACT_APP_*` values are inlined at build time.
// If environment variables are not set during build, these defaults will be used.

// Force HTTPS for production domain regardless of what's set
const rawApiUrl = process.env.REACT_APP_API_URL || "https://api.compliance.proofyx.com";
console.log(rawApiUrl);

// Multiple layers of protection
let finalUrl = rawApiUrl;

// 1. If it contains the production domain, force HTTPS
if (finalUrl.includes("api.compliance.proofyx.com")) {
  finalUrl = finalUrl.replace(/^http:/, "https:");
}

// 2. If we're on HTTPS frontend, force HTTPS backend
if (typeof window !== 'undefined' && window.location.protocol === "https:" && finalUrl.startsWith("http:")) {
  finalUrl = finalUrl.replace(/^http:/, "https:");
}

export const API_URL = finalUrl;

// Debug logging
console.log('[ENV DEBUG] Raw API URL from env:', rawApiUrl);
console.log('[ENV DEBUG] Final API URL:', API_URL);
console.log('[ENV DEBUG] Window protocol:', typeof window !== 'undefined' ? window.location.protocol : 'N/A');
export const TENANT_ID =
  process.env.REACT_APP_TENANT_ID || "8a73c12b-859f-4d0f-9b18-1f04e3cc9231";
export const BACKEND_CLIENT_ID =
  process.env.REACT_APP_BACKEND_CLIENT_ID ||
  "4ea3bce1-4ac0-44c2-b09e-990dc0a53f21";
export const CLIENT_ID =
  process.env.REACT_APP_CLIENT_ID || "7fa9bb72-1bed-44ca-8124-f9f28098231b";
export const AUTH_URL =
  process.env.REACT_APP_AUTH_URL || "https://itvajraexternals.ciamlogin.com";

export const POLICY_HUB_URL = process.env.REACT_APP_POLICY_HUB_URL || "https://policy.proofyx.com";

const env = {
  API_URL,
  TENANT_ID,
  BACKEND_CLIENT_ID,
  CLIENT_ID,
  AUTH_URL,
  POLICY_HUB_URL,
};

export default env;
